const purchaseProcessForm = document.querySelector('.purchase-process-form');

const toggleSlide = (element) => {
  const isVisible = element.offsetHeight > 0;
  if (isVisible) {
    slideUp(element, 300);
  } else {
    slideDown(element, 300, 'flex');
  }
};

const closeAllEditForms = (addresses, currentForm) => {
  addresses.forEach((addr) => {
    const form = addr.querySelector('.purchase-process-form__address-edit-hidden-form');
    if (form && form !== currentForm && form.offsetHeight > 0) {
      slideUp(form, 300);
    }
  });
};

const pickAddresses = () => {
  const addresses = purchaseProcessForm.querySelectorAll('.purchase-process-form__address');

  addresses.forEach((address) => {
    const editButton = address.querySelector('.purchase-process-form__address-edit-button');
    const editForm = address.querySelector('.purchase-process-form__address-edit-hidden-form');

    address.addEventListener('click', (e) => {
      if (editForm && editForm.contains(e.target)) return;

      const clickedEdit = e.target.closest('.purchase-process-form__address-edit-button');

      removeActiveClass(addresses);
      address.classList.add('is-active');

      closeAllEditForms(addresses, editForm);

      if ((!editButton && editForm) || (clickedEdit && editForm)) {
        toggleSlide(editForm);
      }
    });
  });
};

const removeShippingFromCart = () => {
  const shippingPriceEle = document.querySelector('.prices-item__delivery');
  if (shippingPriceEle) {
    const priceLeftEle = shippingPriceEle.querySelector('.purchase-process-sidebar__prices-left');
    const priceRightEle = shippingPriceEle.querySelector('.purchase-process-sidebar__prices-right');
    priceLeftEle.innerHTML = priceLeftEle.dataset.label;
    priceRightEle.innerHTML = priceRightEle.dataset.label;
  }
};

const pasteAddress = () => {
  const savedAddresses = purchaseProcessForm.querySelectorAll('.purchase-process-form__address');
  savedAddresses.forEach((savedAddress, key) => {
    const selectedAddress = savedAddress
      .closest('.purchase-process-form__addresses')
      .querySelector('.purchase-process-form__addresses__right');
    savedAddress.addEventListener('click', () => {
      selectedAddress.innerHTML = savedAddress.querySelector('.purchase-process-form__address-info').innerHTML;
      const mainAddress = selectedAddress.closest('.purchase-process-form__addresses-main');
      mainAddress.querySelector('input').value = key;
      mainAddress.dataset.code = savedAddress.dataset.code;
      removeShippingFromCart();
    });
  });
};

const initCheckoutKeyboard = (form) => {
  if (!form || !window.matchMedia('(pointer: coarse)').matches) return;

  const textInputTypes = ['text', 'email', 'tel', 'number', 'search', 'url', 'password'];
  const isTextInput = (field) => field.tagName === 'INPUT' && textInputTypes.includes(field.type);
  const getFields = () =>
    Array.from(form.querySelectorAll('input, select, textarea')).filter(
      (field) =>
        (isTextInput(field) || field.tagName === 'SELECT' || field.tagName === 'TEXTAREA') &&
        !field.matches(':disabled') &&
        !field.readOnly &&
        field.tabIndex >= 0 &&
        field.getClientRects().length > 0,
    );

  const updateKeyHint = (field) => {
    if (!isTextInput(field)) return;

    const fields = getFields();
    const index = fields.indexOf(field);
    if (index < 0) return;

    field.setAttribute('enterkeyhint', index < fields.length - 1 ? 'next' : 'done');
  };

  getFields().forEach(updateKeyHint);

  form.addEventListener('focusin', (event) => updateKeyHint(event.target));
  form.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Enter' || event.isComposing || !isTextInput(event.target)) return;

      const fields = getFields();
      const index = fields.indexOf(event.target);
      if (index < 0) return;

      event.preventDefault();
      event.stopPropagation();

      const nextField = fields[index + 1];
      if (nextField) {
        nextField.focus();
      } else {
        event.target.blur();
      }
    },
    true,
  );
};

if (purchaseProcessForm) {
  initCheckoutKeyboard(purchaseProcessForm.querySelector('.purchase-process-form__form'));
  // Addresses accordion
  const mainAddress = purchaseProcessForm.querySelector('.purchase-process-form__addresses-main');
  if (mainAddress) {
    const parent = mainAddress.closest('.purchase-process-form__addresses');
    const content = parent.querySelector('.purchase-process-form__addresses-other');
    mainAddress.addEventListener('click', () => {
      mainAddress.classList.toggle('is-active');
      slideToggle(content, 300, 'flex');
    });
  }

  pickAddresses();

  // Checkbox dropdowns
  const dropdowns = document.querySelectorAll('.purchase-process-form__checkbox-dropdown');
  dropdowns.forEach((dropdown) => {
    const checkbox = dropdown.querySelector('.checkbox');
    const input = checkbox.querySelector('input');
    const inputsDropdown = dropdown.querySelector('.purchase-process-form__checkbox-dropdown__inputs');

    input.addEventListener('change', (ev) => {
      if (ev.currentTarget.checked) {
        slideDown(inputsDropdown, 300, 'flex');
      } else {
        slideUp(inputsDropdown, 300, 'none');
        const inputs = inputsDropdown.querySelectorAll('.mod-input');
        inputs.forEach((item) => {
          item.classList.remove('is-validation-failed');
          // const error = item.querySelector('.fv-plugins-message-container');
          // error.innerHTML = '';
        });
      }
    });
  });

  // Change button if paypal option is clicked
  const paymentDropdowns = document.querySelectorAll(
    '.purchase-process-dropdown--payment .purchase-process-dropdown__header',
  );
  paymentDropdowns.forEach((paymentDropdown) => {
    paymentDropdown.addEventListener('click', (ev) => {
      ev.target
        .closest('form')
        .querySelector('.purchase-process-form__footer-btns')
        .classList.toggle('show-paypal', ev.target.id === 'paypal-payment');
    });
  });
  pasteAddress();

  const contactEmail = purchaseProcessForm.querySelector('#contact_email');
  if (contactEmail) {
    let saveTimeout;
    let lastSubmittedEmail = '';
    let lastObservedEmail = '';

    const saveForgottenBasket = () => {
      clearTimeout(saveTimeout);
      const email = contactEmail.value.trim();

      if (!email || !contactEmail.validity.valid || email === lastSubmittedEmail) return;

      const formData = new FormData();
      formData.append('action', 'saveForgottenBasket');
      formData.append('email', email);

      lastSubmittedEmail = email;
      axios.post(window.localData.apiURL, formData).catch((err) => {
        if (lastSubmittedEmail === email) lastSubmittedEmail = '';
        console.error('saveForgottenBasket', err);
      });
    };

    const scheduleSaveForgottenBasket = () => {
      const email = contactEmail.value.trim();
      if (email === lastObservedEmail) return;

      lastObservedEmail = email;
      clearTimeout(saveTimeout);
      saveTimeout = setTimeout(saveForgottenBasket, 500);
    };

    contactEmail.addEventListener('input', scheduleSaveForgottenBasket);
    contactEmail.addEventListener('change', scheduleSaveForgottenBasket);
    contactEmail.addEventListener('focusout', saveForgottenBasket);

    // Some mobile browsers autofill the whole form without input/change events.
    setInterval(scheduleSaveForgottenBasket, 1000);
    scheduleSaveForgottenBasket();
  }
}

// *******************************************************
// Open login modal
// *******************************************************

attachEvent('.open-login-modal', 'click', (openLoginModal) => {
  openLoginModal.target.closest('.purchase-process-form').querySelector('.login-modal').classList.add('is-open-modal');
  toggleBodyScrollLock(true);
});
